import { isOverseas } from '@whelk/const/src/env';
import { MINIMAX_URL_CN, MINIMAX_URL_OVERSEA } from '@whelk/const/src/routerUrl';

export default function useOpenMMX() {
  const openMMX = () => {
    const url = isOverseas ? MINIMAX_URL_OVERSEA : MINIMAX_URL_CN;
    window.open(url);
  };
  return {
    openMMX,
  };
}
